import { Suspense } from 'react'
import { ExpeditionCanvas } from './scene/ExpeditionCanvas.jsx'
import { Interface } from './ui/Interface.jsx'
import { LoadingScreen } from './ui/LoadingScreen.jsx'
import { useReducedMotion } from './hooks/useReducedMotion.js'
import { useDeviceTier } from './hooks/useDeviceTier.js'

export default function App() {
  const reducedMotion = useReducedMotion()
  const device = useDeviceTier()
  return <main className="experience">
    <Suspense fallback={<LoadingScreen />}><ExpeditionCanvas reducedMotion={reducedMotion} device={device} /></Suspense>
    <Interface reducedMotion={reducedMotion} />
  </main>
}
